export default __webpack_public_path__ + "abf0fdd58616d801b5c95320d0d3bd7b.png";